import defaultMember from '@space-shell/assets/images/default-banned-member.svg'
import Avatar from '@space-shell/common/components/avatar'
import clsx from 'clsx'

import type { MemberListCardProps } from './types'

const MemberListCard = ({
  user: { name, userName, email, imagePath },
  action,
  className
}: MemberListCardProps) => (
  <div
    data-test='member-list-card'
    className={clsx('_d-flex align-items-center _mb-0 _px-5 _py-4 _w-full', className)}>
    <div className='_d-flex _justify-content-start _align-items-center'>
      <div className='_mr-4'>
        <Avatar className='_bg-gray-300' size='md' urlAvatar={imagePath || defaultMember} />
      </div>

      <div className='_d-flex _flex-column'>
        <h2 className='_text-2 _text-gray-900 _mb-0'>{name || userName}</h2>

        {email ? (
          <small className='_text-1 _text-gray-900' data-test='card-member-user-email'>
            {email}
          </small>
        ) : null}
      </div>
    </div>

    {action}
  </div>
)

export default MemberListCard
